module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Among the Fair Magnolias: Four Southern Love Stories")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txca",
    attrs: {
      "id": "pz10-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('i', [_vm._v("For My Mother")])])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da1147aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication01.vue
// module id = 66
// module chunks = 0